import { render, staticRenderFns } from "./UserUpdate.vue?vue&type=template&id=bca5c85a"
import script from "./UserUpdate.vue?vue&type=script&lang=ts"
export * from "./UserUpdate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.0.10@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports